'use client'

import { Image, Text } from '@vinted/web-ui'

import { DigitalProductPassportItemDto } from '@marketplace-web/pro-integrations/pro-integrations-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SellButton from '../SellButton'
import { IMAGE_BASE_URL } from '../constants'

const SWOOSH_POSITIONS = ['top-left', 'top-right', 'bottom-right', 'bottom-left'] as const
type SwooshPosition = (typeof SWOOSH_POSITIONS)[number]

const PreviewSection = ({
  dppRef,
  dppItem,
}: {
  dppRef: string
  dppItem: DigitalProductPassportItemDto
}) => {
  const translate = useTranslate('business.digital_product_passport.preview')

  const renderSwoosh = (direction: SwooshPosition) => (
    <div
      className={`digital-product-passport_swoosh digital-product-passport_${direction}`}
      style={{
        backgroundImage: `image-set(
    url("${IMAGE_BASE_URL}/${direction}.png") 1x,
    url("${IMAGE_BASE_URL}/${direction}@2x.png") 2x,
    url("${IMAGE_BASE_URL}/${direction}@3x.png") 3x`,
      }}
    />
  )

  const renderSwooshes = () => {
    return SWOOSH_POSITIONS.map(position => renderSwoosh(position))
  }

  return (
    <section className="digital-product-passport_preview-section">
      <div className="digital-product-passport_preview">
        <div className="digital-product-passport_preview-image">
          <div className="digital-product-passport_preview-image-wrapper">
            <Image
              src={dppItem.image_url}
              alt={dppItem.title}
              testId="digital-product-passport-item-image"
            />
            {renderSwooshes()}
          </div>
        </div>
        <div className="digital-product-passport_item-details">
          <Text as="p">{translate('title')}</Text>
          <Text as="h2" testId="digital-product-passport-item-title">
            {dppItem.title}
          </Text>
          <div
            className="digital-product-passport_tags"
            data-testid="digital-product-passport-item-tags"
          >
            {dppItem.tags.map(tag => (
              <div className="digital-product-passport_tag" key={tag}>
                <Text as="span">{tag}</Text>
              </div>
            ))}
          </div>
          <SellButton dppRef={dppRef} />
        </div>
      </div>
    </section>
  )
}

export default PreviewSection
